import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import LocationPinIcon from '@mui/icons-material/LocationOnOutlined'; // Import LocationPinIcon
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import dayjs from "dayjs";

const groupByDate = (calls: any[]) => {
    return calls.reduce((acc: { [x: string]: any[]; }, call: { date: string | number; }) => {
        if (!acc[call.date]) {
            acc[call.date] = [];
        }
        acc[call.date].push(call);
        return acc;
    }, {});
};

const getLabel = (dateStr: string | number | dayjs.Dayjs | Date | null | undefined) => {
    const today = dayjs().startOf('day');
    const target = dayjs(dateStr);
    if (target.isSame(today, 'day')) return "Today";
    if (target.isSame(today.add(1, 'day'), 'day')) return "Tomorrow";
    return target.format("DD MMM, YYYY");
};
const mapApiResponseToCalls = (apiResponse: any) => {
    return Object.values(apiResponse).flat().map((item: any, index: number) => {
        let timeString = "Unknown Time";

        if (item.meetStarttime && item.meetEndtime) {
            const todayDate = dayjs().format("YYYY-MM-DD"); // today's date
            const start = dayjs(`${todayDate}T${item.meetStarttime}`);
            const end = dayjs(`${todayDate}T${item.meetEndtime}`);

            if (start.isValid() && end.isValid()) {
                timeString = `${start.format("hh:mm A")} - ${end.format("hh:mm A")}`;
            }
        }

        return {
            id: item.meetingId || index,
            title: item.meetTitle || "No Title",
            mentee: item.meetWithUser || "Unknown",
            date: item.meetDate || "Unknown Date",
            time: timeString,
            status: "upcoming",
            link: item.meetLink || "#",
            mode: item.meetMode || "Offline"
        };
    });
};



const UpcomingCalls = ({ upcomingCalls }: { upcomingCalls: any }) => {
    const [visibleCount, setVisibleCount] = useState(3);

    const handleSeeMore = () => {
        setVisibleCount(prev => prev + 2); // load 2 more
    };

    console.log(upcomingCalls, "upcomingCallsupcomingCallsupcomingCalls");
    const mappedCalls = mapApiResponseToCalls(upcomingCalls);
    console.log(mappedCalls, "mappedCallsmappedCallsmappedCalls");

    const groupedData = groupByDate(mappedCalls);
    const sortedDates = Object.keys(groupedData).sort();
    console.log(groupedData, sortedDates, "groupedData[date]groupedData[date]");
    return (
        <div style={{ overflow: "visible", height: "auto" }}>
            {sortedDates.length === 0 ? (
                <Grid container justifyContent="center" alignItems="center" style={{ height: "100%" }}>
                    <Typography variant="body2" color="#888" sx={{ width: "100%", textAlign: "center", py: 3 }}>
                        No upcoming calls
                    </Typography>
                </Grid>
            ) : (
                <> 
                {


                    sortedDates.slice(0, visibleCount).map((date, index) => {

                        // sortedDates.map(date => {
                        const label = getLabel(date);

                        return (
                            <Grid key={date} mb={2}>
                                <Typography mb={1} textAlign={"center"} fontSize={12} color={"#585A64"}>
                                    {label}
                                </Typography>
                                {groupedData[date].map((call: any) => (

                                    <Grid
                                        key={call.id}
                                        container
                                        spacing={1.5}
                                        fontSize={14}
                                        sx={{
                                            borderLeft: `3px solid ${call.mode === "Online" ? "#F7A703" : "rgb(71 92 161)"}`,
                                            backgroundColor: "#f6f8fb",
                                            px: 1.5,
                                            py: 1.5,
                                            borderRadius: 2,
                                            width: "100%",
                                            margin: 0,
                                            mb: 1.25,
                                            alignItems: "center",
                                        }}
                                    >
                                        <Grid item xs={8} md={6} lg={6} xl={6}>
                                            <Typography sx={{
                                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                                    fontSize: 14,
                                                },

                                            }} color={"#373A45"} fontWeight={600}>
                                                {call.title}
                                            </Typography>
                                            <Typography sx={{
                                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                                    fontSize: 12,
                                                },

                                            }} color={"#373A45"}>
                                                Mentee: {call.mentee}
                                            </Typography>

                                        </Grid>
                                        <Grid item xs={4} md={6} lg={6} xl={6} sx={{ textAlign: "right" }}>
                                            <Typography
                                                fontWeight={500}
                                                color={"#585A64"}
                                                sx={{
                                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                                        fontSize: 12,
                                                    },

                                                }}
                                            >
                                                {/* Re-schedule{" "} */}
                                                {call.mode === "Online" ? (
                                                    <VideocamOutlinedIcon
                                                        style={{
                                                            backgroundColor: "#F7A703",
                                                            color: "white",
                                                            height: 35,
                                                            width: 35,
                                                            padding: 6,
                                                            borderRadius: "50%",
                                                        }}
                                                        onClick={() => {
                                                            if (call.link && call.link !== "#") {
                                                                window.open(call.link, "_blank");
                                                            }
                                                        }}
                                                    />
                                                ) : (
                                                    <LocationPinIcon
                                                        style={{
                                                            backgroundColor: "#388E3C",
                                                            color: "white",
                                                            height: 35,
                                                            width: 35,
                                                            padding: 6,
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sx={{ pl: 0.5 }}>
                                            <Typography
                                                sx={{
                                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                                        fontSize: 12,
                                                    },

                                                }} color={"#373A45"} mt={1}>
                                                <AccessTimeOutlinedIcon style={{ marginRight: 5, fontSize: 18 }} />
                                                {call.time}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                ))}
                            </Grid>
                        );
                    })
                }
                    {visibleCount < sortedDates.length && (
                        <Box sx={{ textAlign: 'center', mt: 2 , mb:4}}>
                            <Button
                                onClick={handleSeeMore}
                                variant="contained"
                                color="secondary"
                                size="small"
                               fullWidth
                            >
                                View More
                            </Button>
                        </Box>
                    )}
                </>
            )}
        </div>
    );
};

export default UpcomingCalls;
